import { useId } from "react";
import { platformSwitchLabel } from "@/constants/adminCollections";

interface PlatformSwitchProps {
  name: string;
  checked: boolean;
  disabled: boolean;
  /** Why the switch is locked: a tooltip, and exposed to assistive tech via aria-describedby. */
  title?: string;
  onToggle: () => void;
}

export default function PlatformSwitch({
  name,
  checked,
  disabled,
  title,
  onToggle,
}: PlatformSwitchProps) {
  const reasonId = useId();
  return (
    <>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={platformSwitchLabel(name)}
        aria-describedby={title ? reasonId : undefined}
        title={title}
        disabled={disabled}
        onClick={onToggle}
        className={`relative h-[22px] w-[38px] shrink-0 rounded-full border-0 p-0 transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-dark-dust ${
          checked ? "bg-[#AF9577]" : "bg-[#E0E0E0]"
        } ${disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"}`}
      >
        <span
          aria-hidden
          className={`absolute top-[2px] left-[2px] h-[18px] w-[18px] rounded-full bg-white shadow transition-transform ${
            checked ? "translate-x-4" : "translate-x-0"
          }`}
        />
      </button>
      {title && (
        <span id={reasonId} className="sr-only">
          {title}
        </span>
      )}
    </>
  );
}
